<template>
  <div class="quote__list-insured">
    <div class="quote__accordion">
      <BaseAccordion>
        <template v-slot:name>
          {{ title }}
        </template>
        <template v-slot:content>
          <ul class="quote__policy-list">
            <!-- <div class="quote__edit"></div> -->
            <template v-if="plateNumber && plateNumber.replaceAll(' ', '')">
              <li>
                  <div class="quote__policy-name">{{$t('qic_quote_motor_info_plate_number')}}</div>
                  <div class="quote__policy-value">{{ plateNumber }}</div>
              </li>
              <li>
                  <div class="quote__policy-name">{{$t('qic_quote_motor_info_plate_type')}}</div>
                  <div class="quote__policy-value">{{ plateType }}</div>
              </li>
            </template>
            <li>
                <div class="quote__policy-name">{{$t('qic_quote_motor_info_chassis')}}</div>
                <div class="quote__policy-value">{{ chassisNumber }}</div>
            </li>
          </ul>
        </template>
      </BaseAccordion>
    </div>
  </div>
</template>

<script>
import BaseAccordion from '../BaseAccordion.vue'
export default {
  name: 'QuoteMotorInfo',
  props: {
    title: { type: String, default: 'No title' },
    plateNumber: {},
    plateType: {},
    chassisNumber: {}
  },
  components: {
    BaseAccordion
  }
}
</script>
